/**
 * Design Tokens for Aion Management Theme
 * 
 * Extends the base stadium-house theme tokens with Aion Management branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-stadium-house/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Aion Management brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Aion Management brand colors - customize these
    // primary: '#your-primary-color',
    // secondary: '#your-secondary-color',
    // accent: '#your-accent-color',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    heading: '"Montserrat", sans-serif',
    body: '"Montserrat", sans-serif',
    accent: '"Montserrat", sans-serif',
  },
};

export default tokens;
